import { Chip } from "@mui/material";

export const LabelChip = ({
  label,
  value,
  icon,
  color = "default",
  backgroundColor = "default",
}) => (
  <Chip
    icon={icon}
    label={
      <span style={{ fontSize: "0.75rem" }}>
        <strong>{label}:</strong> {value}
      </span>
    }
    size="small"
    color={color}
    sx={{
      mr: 0.8,
      mb: 0.5,
      px: 1,
      borderRadius: 1.5,
      fontWeight: 500,
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
      backgroundColor: { backgroundColor },
    }}
    variant="outlined"
  />
);
